/**
 * Strip Svelte `$state` (and other) Proxies into IndexedDB-safe plain data.
 * Structured clone rejects Proxies with DataCloneError; JSON round-trip does not.
 */
export function toPlainJson<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}
